import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitInterestedBuyersWidgets } from '~/config/widgets/cockpit/cockpitInterestedBuyersWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_INTEREST,
  cockpitInterestedBuyersWidgets,
  true,
);
